export default __webpack_public_path__ + "static/media/12-24.f4689b0a.jpeg";